import React from 'react';
import styled from 'styled-components';
import withPageEntry from '../../withPageEntry';
import * as AppActions from '../../AppActions';
import * as JStorage from '../../JStorage';
import Theme from '../../Theme';
import * as Ant from 'antd';
import {useOutlet} from 'reconnect.js';
import Breadcrumb from '../../Components/Breadcrumb';
import useArea from '../../Hooks/useArea';

const pageSize = 20;
const pageRoute = '/profile/evt-reg/';
const collectionName = 'event_registration';

function EventRegListWeb(props) {
  const [user] = useOutlet('user');
  const [paging, setPaging] = React.useState({offset: 0, limit: pageSize});
  const [fetchResp, setFetchResp] = React.useState(null);
  const {area} = useArea();

  const fetchDocumentList = React.useCallback(async () => {
    AppActions.setLoading(true);
    try {
      const extraQuery = {owner: user.sub};
      const resp = await JStorage.fetchDocuments(
        collectionName,
        extraQuery,
        ['-date'],
        paging,
      );

      setFetchResp(resp);
    } catch (ex) {
      console.warn(ex);
    }
    AppActions.setLoading(false);
  }, [paging, user]);

  React.useEffect(() => {
    fetchDocumentList();
  }, [fetchDocumentList]);

  return (
    <Wrapper>
      <div className="tda-header">
        <h2>活動報名紀錄</h2>
        <Breadcrumb />
      </div>

      <Ant.Table
        columns={[
          {
            title: '活動',
            key: 'event_id',
            render: (_, record) => {
              return (
                <div>
                  <Ant.Button
                    type="link"
                    onClick={() =>
                      AppActions.navigate(
                        `/profile/event-registration?reg_id=${record.id}`,
                      )
                    }
                    style={{padding: 0, marginRight: 20}}>
                    報名紀錄
                  </Ant.Button>
                  <Ant.Button
                    type="link"
                    onClick={() =>
                      AppActions.navigate(
                        `/${area}/events/content?id=${record.product.id}`,
                      )
                    }
                    style={{padding: 0}}>
                    {record.product?.name}
                  </Ant.Button>
                </div>
              );
            },
            responsive: ['sm'],
          },
          {
            title: '報名日期',
            key: 'title',
            render: (_, record) => {
              return (
                <div>
                  <div>{new Date(record.created).toLocaleDateString('sv')}</div>
                </div>
              );
            },
            responsive: ['sm'],
          },
          {
            title: '狀態',
            key: 'status',
            render: (_, record) => {
              const StatusDisplay = {
                success: '報名成功',
                failure: '報名失敗',
              };
              return StatusDisplay[record.status] || '報名中';
            },
            responsive: ['sm'],
          },
          {
            title: '活動',
            key: 'mobile-field',
            render: (_, record) => {
              const StatusDisplay = {
                success: '報名成功',
                failure: '報名失敗',
              };
              return (
                <div>
                  <Ant.Button
                    type="link"
                    onClick={() =>
                      AppActions.navigate(
                        `/${area}/events/content?id=${record.product.id}`,
                      )
                    }
                    style={{padding: 0}}>
                    {record.product?.name}
                  </Ant.Button>
                  <Ant.Button
                    type="link"
                    onClick={() =>
                      AppActions.navigate(
                        `/profile/event-registration?reg_id=${record.id}`,
                      )
                    }
                    style={{padding: 0, marginRight: 20}}>
                    報名紀錄
                  </Ant.Button>
                  <div>
                    報名日期：
                    {new Date(record.created).toLocaleDateString('sv')}
                  </div>
                  <div>狀態：{StatusDisplay[record.status] || '報名中'}</div>
                </div>
              );
            },
            responsive: ['xs'],
          },
        ]}
        dataSource={fetchResp?.results}
        rowKey={'id'}
        pagination={{
          size: 'small',
          total: fetchResp?.total || 0,
          showSizeChanger: false,
          showTotal: (total) => `共 ${total} 筆, 每頁 ${pageSize} 筆`,
          current: paging.offset / pageSize + 1,
          pageSize: pageSize,
          position: ['bottomCenter'],
          onChange: (page, pageSize) => {
            if (pageSize) {
              setPaging({
                offset: (page - 1) * pageSize,
                limit: pageSize,
              });
            }
          },
        }}
      />
    </Wrapper>
  );
}

const Wrapper = styled.div``;

export default withPageEntry(EventRegListWeb);
